import { exact, number, oneOfType, string } from "prop-types";

const antdFlexType = oneOfType([string, number]);
const antdColSpanType = oneOfType([string, number]);
const antdColSizeType = exact({
  flex: antdFlexType,
  span: antdColSpanType,
  order: antdColSpanType,
  offset: antdColSpanType,
  push: antdColSpanType,
  pull: antdColSpanType,
});

/** @deprecated use TypeScript interface or type instead */
export const antdWrapperColType = exact({
  flex: antdFlexType,
  span: antdColSpanType,
  order: antdColSpanType,
  offset: antdColSpanType,
  push: antdColSpanType,
  pull: antdColSpanType,
  xs: oneOfType([antdColSpanType, antdColSizeType]),
  sm: oneOfType([antdColSpanType, antdColSizeType]),
  md: oneOfType([antdColSpanType, antdColSizeType]),
  lg: oneOfType([antdColSpanType, antdColSizeType]),
  xl: oneOfType([antdColSpanType, antdColSizeType]),
  xxl: oneOfType([antdColSpanType, antdColSizeType]),
  prefixCls: string,
});
